export const itemHoverColor = '#f9fafb';
export const linkColor = '#4469a6';
export const secondaryText = '#6b7280';
export const greenBackground = '#c8e6c9';
export const greenBackgroundDark = '#b6deb8';
export const greenText = '#388e3c';
export const redBackground = '#ffcdd2';
export const redText = '#d32f2f';

export const alterColor = (hexColor: string, magnitude: number) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};
